<template>
  <span class="loader" :style="spinnerStyle"></span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface SpinnerProps {
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  color?: string;
}

const props = withDefaults(defineProps<SpinnerProps>(), {
  size: 'medium',
  color: 'blue-800',
});

const sizeMap = {
  xsmall: '10px',
  small: '20px',
  medium: '32px',
  large: '48px',
};

const borderWidthMap = {
  xsmall: '1.5px',
  small: '2.5px',
  medium: '3.5px',
  large: '4px',
};

const getColorValue = (colorClass: string) => {
  return `var(--color-${colorClass})`;
};

const spinnerStyle = computed(() => {
  const dimension = sizeMap[props.size];
  const borderWidth = borderWidthMap[props.size];
  const resolvedColor = getColorValue(props.color);

  return {
    width: dimension,
    height: dimension,
    borderWidth: borderWidth,
    borderColor: resolvedColor,
    borderBottomColor: 'transparent',
  };
});
</script>

<style scoped>
.loader {
  border-style: solid;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
